import KeenSlider from 'keen-slider';
if (!customElements.get('ia-product-gallery')) {

  class IAProductGallery extends HTMLElement {
    constructor() {
      super();
      this.mainSlider = null;
      this.thumbSlider = null;
      this.currentSlideElement = null;
      this.prevButton = null;
      this.nextButton = null;
      this.mainSliderEl = this.querySelector('.ia-product-gallery__slider');
      this.thumbSliderEl = this.querySelector('.ia-product-gallery__thumbs');
      this.autoplay = this.getAttribute('data-autoplay') === 'true';
    }
  
    connectedCallback() {
      this.initializeSlideshow();
    }
  
    disconnectedCallback() {
      if (this.mainSlider) {
        this.mainSlider.destroy();
      }
      if (this.thumbSlider) {
        this.thumbSlider.destroy();
      }
    }

    ThumbnailPlugin(main) {
      return (slider) => {
        const removeActive = () => {
          slider.slides.forEach((slide) => {
            slide.classList.remove("active")
          })
        }

        const addActive = (idx) => {
          slider.slides[idx].classList.add("active")
        }

        const addClickEvents = () => {
          slider.slides.forEach((slide, idx) => {
            slide.addEventListener("click", () => {
              main.moveToIdx(idx)
            })
          })
        }

        slider.on("created", () => {
          addActive(slider.track.details.rel)
          addClickEvents()
          main.on("animationStarted", (main) => {
            removeActive()
            const next = main.animator.targetIdx || 0
            const relativeIndex = main.track.absToRel(next)
            addActive(relativeIndex)
            
            const thumbSliderDetails = slider.track.details
            const maxIdx = thumbSliderDetails.maxIdx
            const slidesPerView = thumbSliderDetails.slidesPerView || 1
            
            let targetIdx = relativeIndex - Math.floor(slidesPerView / 2)
            targetIdx = Math.max(0, Math.min(maxIdx, targetIdx))
            
            slider.moveToIdx(targetIdx)

          })
        })
      }
    }
  
    initializeSlideshow() {

      this.currentSlideElement = this.querySelector('.js-ia-slideshow-current');
      this.prevButton = this.querySelector('.js-ia-slideshow-prev');
      this.nextButton = this.querySelector('.js-ia-slideshow-next');
  
      if (!this.mainSliderEl) {
        return;
      }

      this.mainSlider = new KeenSlider(this.mainSliderEl, {
        loop: true,
        initial: 0,
        slides: {
          perView: this.mainSliderEl.style.getPropertyValue('--items-desktop'),
          spacing: this.mainSliderEl.style.getPropertyValue('--spacing-desktop').replace('px', ''),
        },
        breakpoints: {
          '(max-width: 768px)': {
            slides: {
              perView: this.mainSliderEl.style.getPropertyValue('--items-mobile'),
              spacing: this.mainSliderEl.style.getPropertyValue('--spacing-mobile').replace('px', ''),
            },
          },
        },
        created: () => {
          this.classList.remove('is-loading');
        }
      });

      if (this.thumbSliderEl) {
        this.thumbSlider = new KeenSlider(
          this.thumbSliderEl,
          {
            initial: 0,
            slides: {
              perView: this.thumbSliderEl.style.getPropertyValue('--items-desktop'),
              spacing: this.thumbSliderEl.style.getPropertyValue('--spacing-desktop').replace('px', ''),
            },
            breakpoints: {
              '(max-width: 768px)': {
                slides: {
                  perView: this.thumbSliderEl.style.getPropertyValue('--items-mobile'),
                  spacing: this.thumbSliderEl.style.getPropertyValue('--spacing-mobile').replace('px', ''),
                },
              },
            },
            created: () => {

            }
          },
          [this.ThumbnailPlugin(this.mainSlider)]
        );
      }

      this.mainSlider.on('slideChanged', () => {
        const currentIndex = this.mainSlider.track.details.rel;
        if (currentIndex >= 0 && this.currentSlideElement) {
          this.currentSlideElement.textContent = currentIndex + 1;
        }
      });

      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => {
          this.mainSlider.prev();
        });
      }

      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => {
          this.mainSlider.next();
        });
      }
    }

    next() {
      if (this.mainSlider) {
        this.mainSlider.next();
      }
    }

    prev() {
      if (this.mainSlider) {
        this.mainSlider.prev();
      }
    }

    goToSlide(index) {
      if (this.mainSlider) {
        this.mainSlider.moveToIdx(index);
      }
    }

    destroy() {
      if (this.mainSlider) {
        this.mainSlider.destroy();
        this.mainSlider = null;
      }
      if (this.thumbSlider) {
        this.thumbSlider.destroy();
        this.thumbSlider = null;
      }
    }
  }
  

  customElements.define('ia-product-gallery', IAProductGallery); 
}